import {
  ProposalAICreatedCatalogProvider,
  ProposalAIGenerator,
} from 'modules/ai';
import {
  EditorHeader,
  Proposal,
  ProposalPrices,
  SegmentList,
  useProposalSegments,
} from 'modules/proposals';
import React from 'react';
import { useFormContext } from 'react-hook-form';

interface Props {
  proposal: PublishStatusAware<Proposal>;
}

export const TableOfContentsView: React.FC<Props> = ({ proposal }) => {
  const proposalSegments = useProposalSegments();
  const { formState } = useFormContext<PublishStatusAware<Proposal>>();

  return (
    <ProposalAICreatedCatalogProvider>
      <EditorHeader />
      <div className="wrapper--editor">
        <ProposalAIGenerator proposalSegments={proposalSegments} />
        <SegmentList
          proposalSegments={proposalSegments}
          formState={formState}
        />
        <ProposalPrices proposal={proposal} />
      </div>
    </ProposalAICreatedCatalogProvider>
  );
};
